import { useParams } from 'react-router-dom'

import { useAnalysisTargetGetApi } from '@/common/api/modules/mediaAnalysisTarget'
import { useSiteId } from '@/common/app/site'

import DetailPageLoader from '@/components/container/DetailPageLoader'
import AnalysisTargetEditPage from '@/components/container/page/site/media/analysisTarget/AnalysisTargetEditPage'

const AnalysisTargetUpdatePage = () => {
  const siteId = useSiteId()
  const { targetId } = useParams()

  const { data, error, mutate } = useAnalysisTargetGetApi({
    siteId,
    targetId: Number(targetId)
  })

  return (
    <DetailPageLoader error={error} data={data} small>
      <AnalysisTargetEditPage target={data} onRefetch={() => mutate()} />
    </DetailPageLoader>
  )
}

export default AnalysisTargetUpdatePage
